module.exports = __webpack_public_path__ + "img/foreo-menu.9c48e4aa.png";